jQuery(function ($) {
  const $component = $('.text-switcher');
  if (!$component.length) return;

  $component.each(function () {
    const $this   = $(this);
    const $nums   = $this.find('.text-switcher__num');
    const $panels = $this.find('.text-switcher__panel');

    $nums.on('click', function () {
      const $btn   = $(this);
      const idx    = $nums.index($btn);
      const $next  = $panels.eq(idx);
      const $active = $panels.filter('.is-active');

      if ($btn.hasClass('is-active')) return;

      $nums.removeClass('is-active');
      $btn.addClass('is-active');

      $active.addClass('is-leaving');

      const DURATION = 350;
      let done = false;

      function swap() {
        if (done) return;
        done = true;
        $active.removeClass('is-active is-leaving');
        $next.addClass('is-active');
      }

      $active.one('transitionend', swap);
      setTimeout(swap, DURATION);
    });
  });
});
